import React from "react";
import { Box, useTheme } from "@mui/material";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { tokens } from "../theme";
import { dataGridStyles, localeText } from "../utils/dataGridConfig";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

const ProductsList = ({ productsList, setProductsList, isReadOnly = false }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Use the provided productsList
  const products = productsList || [];

  // Function to handle the deletion of a product
  const handleDeleteProduct = (id) => {
    if (productsList) {
      const updatedProducts = productsList.filter((product) => product.product_id !== id);
      setProductsList(updatedProducts);
    }
  };

  // Define columns for the DataGrid
  const columns = [
    {
      field: "name",
      headerName: "Producto",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "quantity",
      headerName: "Cantidad Presentación",
      type: "number",
      headerAlign: "left",
      align: "left",
      flex: 0.8,
    },
    {
      field: "presentation",
      headerName: "Presentación",
      type: "number",
      headerAlign: "left",
      align: "left",
      flex: 0.7,
    },
    {
      field: "presentation_price",
      headerName: "Precio Presentación",
      type: "number",
      headerAlign: "left",
      align: "left",
      flex: 1,
      valueFormatter: (value) => `$${value}`,
    },
    {
      field: "total_quantity",
      headerName: "Cantidad Total",
      type: "number",
      headerAlign: "left",
      align: "left",
      flex: 0.8,
      renderCell: (params) => {
        if (!isReadOnly){
          const row = params.row;
          return row.presentation * row.quantity
        } else {
          return params.row.quantity
        }
      }
    },
    {
      field: "unit_price",
      headerName: "Precio Unitario",
      type: "number",
      headerAlign: "left",
      align: "left",
      flex: 0.8,
      renderCell: (params) => {
        if (!isReadOnly){
          return `$${params.row.presentation_price/params.row.quantity}`
        } else {
          return `$${params.row.unit_price}`
        }
      }
    },
    {
      field: "total_price",
      headerName: "Precio Total",
      type: "number",
      headerAlign: "left",
      align: "left",
      flex: 0.8,
      renderCell: (params) => {
        if (!isReadOnly) {
          const row = params.row;
          return `$${row.presentation * row.presentation_price}`
        } else{
          return `$${params.row.total_price}`
        }
      },
    },
  ];

  // Define column visibility model
  const columnVisibilityModel = {
    presentation: !isReadOnly,
    presentation_price: !isReadOnly,
    quantity: !isReadOnly,
  };

  // Add the "Actions" column only if isReadOnly is false
  if (!isReadOnly) {
    columns.push({
      field: "actions",
      type: "actions",
      headerName: "Acciones",
      flex: 0.6,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<DeleteOutlinedIcon />}
          label="Delete"
          onClick={() => handleDeleteProduct(params.id)}
        />,
      ],
    });
  }

  return (
    <Box height="40vh" sx={dataGridStyles(colors)}>
      <DataGrid
        rows={products}
        columns={columns}
        getRowId={(row) => row.product_id}
        pageSizeOptions={[100]}
        loadingText="Cargando..."
        localeText={localeText}
        disableRowSelectionOnClick
        disableColumnMenu
        disableColumnSorting
        columnVisibilityModel={columnVisibilityModel}
      />
    </Box>
  );
};

export default ProductsList;